import React from 'react';

import { Box, Typography } from '@mui/material';
import NavNeededCountBadge from '@sharedCR/common/NavNeededCountBadge';
import { ACTION_CELL_WIDTH_WITH_BADGES } from '@sharedCR/common/SimpleTable/SimpleTable.constants';
import { ENTITY_REFERENCE_TYPE } from 'app/shared/components/TeamChat/TeamChat.entityReferences.utils';
import TeamChatReferenceBadge from 'app/shared/components/TeamChat/TeamChatReferenceBadge';

import { occupancyMap, propertyStatusMap } from 'constants/options';
import { PendingChangesActionType } from 'constants/pendingChanges';
import { formatNumberToCurrencyString } from 'utils/number';

import { FINANCIAL_INFO_VIEWS_PATHS } from '../../FinancialInfo.constants';
import ActionButton from '../ActionButton';
import {
  actionCellStyles,
  getWrappedTextStyles,
  headCellLabelStyles,
  sharedTypographyStyles,
} from '../FinancialInfoBody.styles';

export const getConfig = ({ onRemove, chatTargets = null, neededCountById = {} }) => ({
  address: {
    label: 'Address',
    width: '27.5%',
    colSpan: ({ address }) => address?.colSpan,
    customStyles: ({ address }) => address?.customStyles,
    content: ({ address, addressLine1, addressLine2 }) =>
      address?.content ?? (
        <Typography data-truncated className="truncate" variant="regular14">
          {addressLine1}
          <br />
          {addressLine2}
        </Typography>
      ),
  },
  occupancyType: {
    label: (
      <Typography data-truncated sx={headCellLabelStyles} variant="regular14">
        Intended Occupancy
      </Typography>
    ),
    width: '22.5%',
    content: ({ occupancyType }) => (
      <Typography data-truncated sx={getWrappedTextStyles()} variant="regular14">
        {occupancyMap[occupancyType?.type]?.name ?? '-'}
      </Typography>
    ),
  },
  status: {
    label: (
      <Typography data-truncated sx={headCellLabelStyles} variant="regular14">
        Property Status
      </Typography>
    ),
    width: '20%',
    content: ({ status }) => (
      <Typography
        data-truncated
        className="truncate"
        sx={sharedTypographyStyles}
        variant="regular14"
      >
        {propertyStatusMap[status]?.name ?? '-'}
      </Typography>
    ),
  },
  netIncome: {
    label: (
      <Typography data-truncated sx={headCellLabelStyles} variant="regular14">
        Net Income/Loss
      </Typography>
    ),
    width: '20%',
    content: ({ netIncome }) => (
      <Typography
        data-truncated
        className="truncate"
        sx={sharedTypographyStyles}
        variant="regular14"
      >
        {netIncome ? formatNumberToCurrencyString(netIncome) : '-'}
      </Typography>
    ),
  },
  action: {
    label: 'Action',
    width: ACTION_CELL_WIDTH_WITH_BADGES,
    content: ({ id, pendingChangesActionType, isSubjectProperty }) => {
      const isAdded = pendingChangesActionType === PendingChangesActionType.ADDED;

      return (
        <Box sx={actionCellStyles}>
          <NavNeededCountBadge count={neededCountById[id] ?? 0} />
          <TeamChatReferenceBadge
            chatId={chatTargets?.internalChatId}
            entityId={id}
            entityType={ENTITY_REFERENCE_TYPE.REO}
          />
          <ActionButton
            chatTargets={chatTargets}
            entityType={ENTITY_REFERENCE_TYPE.REO}
            id={id}
            isHighlighted={isAdded}
            isRemoveDisabled={isSubjectProperty}
            removeText="Delete REO"
            tablePath={FINANCIAL_INFO_VIEWS_PATHS.REO}
            onRemove={onRemove}
          />
        </Box>
      );
    },
    align: 'center',
  },
});
